import { useEffect, useState } from "react";
import "./promoView.css";

const PromoView = ({
  currentCompany,
  setCurrentCompany,
  companies,
  setCompanies,
}) => {
  const [newCompany, setNewCompany] = useState(currentCompany);

  const handleSave = () => {
    const newCompanies = companies.map((company) => {
      if (currentCompany.name === company.name) {
        return newCompany;
      } else return company;
    });
    setCompanies(newCompanies);
    localStorage.setItem("companies", JSON.stringify(newCompanies));
    setCurrentCompany(null);
  };

  useEffect(() => {
    setNewCompany(currentCompany);
  }, [currentCompany]);

  return (
    <>
      {newCompany?.checkedAttributes.includes("name") && (
        <section className="promotions-name">
          <span className="promotions-name-text">Ime firme:</span>
          <input
            name="promotions-name"
            className="promotions-name-input"
            value={newCompany.name}
            onChange={(e) =>
              setNewCompany({ ...newCompany, name: e.target.value })
            }
          />
        </section>
      )}
      {newCompany?.checkedAttributes.includes("email") && (
        <section className="promotions-name">
          <span className="promotions-name-text">E-mail firme:</span>
          <input
            name="promotions-name"
            className="promotions-name-input"
            value={newCompany.email}
            onChange={(e) =>
              setNewCompany({ ...newCompany, email: e.target.value })
            }
          />
        </section>
      )}
      {currentCompany?.checkedAttributes.includes("location") && (
        <div className="promotions-locations">Locations</div>
      )}
      {currentCompany?.checkedAttributes.includes("workFields") && (
        <div className="promotions-workfields">Workfields</div>
      )}
      {currentCompany?.checkedAttributes.includes("employees") && (
        <div className="promotions-employees">Employees</div>
      )}
      {currentCompany?.checkedAttributes.includes("messages") && (
        <div className="promotions-messages">Messages</div>
      )}
      {currentCompany?.checkedAttributes.includes("presentation") && (
        <div className="promotions-presentation">Presentation</div>
      )}
      {currentCompany?.checkedAttributes.includes("images") && (
        <section className="promotions-images">
          <h4 className="promotions-images-title">
            Slike firme {currentCompany.name}
          </h4>
          <div className="promotions-images-grid">
            {currentCompany.images.length !== 0 &&
              currentCompany.images.map((image, i) => {
                return (
                  <img
                    key={i}
                    src={image}
                    alt=""
                    className="promotions-image"
                  />
                );
              })}
          </div>
        </section>
      )}
      {currentCompany?.checkedAttributes.includes("phone") && (
        <div className="promotions-phone">Phone</div>
      )}
      {currentCompany?.checkedAttributes.includes("folder") && (
        <div className="promotions-folder">Folder</div>
      )}
      {currentCompany && (
        <button className="promotions-btn" onClick={handleSave}>
          Zapamti
        </button>
      )}
    </>
  );
};

export default PromoView;
